import { z } from "zod";
import { LOCALE_VALUES, type Locale } from "../enum.js";

export interface ChangelogTranslation {
	id: string;
	changelog_id: string;
	locale: Locale;
	title: string;
	body_md: string;
}

export interface Changelog {
	id: string;
	version: string;
	is_published: boolean;
	published_at: Date | null;
	created_at: Date;
	updated_at: Date;
	translations: ChangelogTranslation[];
}

const semverPattern = /^\d+\.\d+\.\d+$/;

export const changelogTranslationInputSchema = z.object({
	locale: z.enum(LOCALE_VALUES),
	title: z.string().min(1).max(200),
	body_md: z.string().min(1).max(10000),
});

export type ChangelogTranslationInput = z.infer<typeof changelogTranslationInputSchema>;

export const createChangelogSchema = z.object({
	version: z.string().regex(semverPattern, { message: "Must be semver X.Y.Z" }),
	is_published: z.boolean().default(false),
	translations: z.array(changelogTranslationInputSchema).min(1),
});

export type CreateChangelogPayload = z.infer<typeof createChangelogSchema>;

export const updateChangelogSchema = z.object({
	version: z.string().regex(semverPattern, { message: "Must be semver X.Y.Z" }).optional(),
	is_published: z.boolean().optional(),
	translations: z.array(changelogTranslationInputSchema).min(1).optional(),
});

export type UpdateChangelogPayload = z.infer<typeof updateChangelogSchema>;

export const changelogVersionQuerySchema = z.object({
	locale: z.enum(LOCALE_VALUES).optional(),
});

export type ChangelogVersionQuery = z.infer<typeof changelogVersionQuerySchema>;
